import { FilterDocument, FilterOptionKeys, TaskType } from '@griply/types';

import { isShowingHabits } from './is-showing-habits';

export const toggleHabitsInFilterDocument = (
  filterDocument: FilterDocument,
): FilterDocument => {
  const currentFilters = filterDocument.filters ?? {};
  const currentTypeFilter = currentFilters[FilterOptionKeys.Type] ?? {
    include: null,
    noTag: false,
  };

  if (isShowingHabits(filterDocument)) {
    return {
      ...filterDocument,
      filters: {
        ...currentFilters,
        [FilterOptionKeys.Type]: {
          ...currentTypeFilter,
          include: [TaskType.Task, TaskType.Repeating],
        },
      },
    };
  }

  const { [FilterOptionKeys.Type]: _removed, ...otherFilters } = currentFilters;
  return {
    ...filterDocument,
    filters: otherFilters,
  };
};
